import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import {AppModule} from './app/app.module';
import {environment} from './environments/environment';

declare global {
    interface Window {
        googleMapsApiReady?: Promise<void>;
        initGoogleMapsApi?: () => void;
        rejectGoogleMapsApi?: (error: Error) => void;
    }
}

if (environment.production) {
    enableProdMode();
}

const mapsApiReady = window.googleMapsApiReady || Promise.resolve();

mapsApiReady
    .then(() => platformBrowserDynamic().bootstrapModule(AppModule))
    .catch((err) => console.error(err));
